import {
  USER_SIGNOUT,
  GAMETEXTE_FROM,
  GAMETEXTE_TO,
  GAMETEXTE_FROMTO_VISIBLE,
  GAMETEXTE_CHOICE,
  GAMETEXTE_SELF,
  GAMETEXTE_MULTI,
  GAMETEXTE_ONLYFOCUS
} from "../actionTypes";

function gameTexteReducers(
  state = {
    from: {},
    to: {},
    visible_from_to: true,
    game_choice: "self",
    onlyFocus: false,
    self: {
      font: "no",
      randoms: [],
      solution: false,
      position: 0,
      guess: '',
      answer: ''
    },
    multi: {
      font: "no",
      randoms: [],
      solution: false,
      position: 0,
      attempt: -1,
      choices: [],
      guess: '',
      answer: ''
    },
  },
  action
) {
  switch (action.type) {
    case USER_SIGNOUT:
      return {
        ...state,
        from: {},
        to: {},
        onlyFocus: false,
        self: {
          font: "no",
          randoms: [],
          solution: false,
          position: 0,
          guess: '',
          answer: ''
        },
        multi: {
          font: "no",
          randoms: [],
          solution: false,
          position: 0,
          attempt: -1,
          choices: [],
          guess: '',
          answer: ''
        },
      };
    case GAMETEXTE_FROM:
      return { ...state, from: action.payload };
    case GAMETEXTE_TO:
      return { ...state, to: action.payload };
    case GAMETEXTE_FROMTO_VISIBLE:
      return { ...state, visible_from_to: action.payload };
    case GAMETEXTE_CHOICE:
      return { ...state, game_choice: action.payload };
    case GAMETEXTE_SELF:
      return { ...state, self: action.payload };
    case GAMETEXTE_MULTI:
      return { ...state, multi: action.payload };
    case GAMETEXTE_ONLYFOCUS:
      return { ...state, onlyFocus: action.payload };
    default:
      return state;
  }
}

export { gameTexteReducers };
